export class FoodAlcoholContentModel {
    public foodAndAlcoholId: number;
    public langId: number;
    public foodAndAlcoholName: string;
    public description: string;
}